// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__2oqrK","modalForm":"UpgradeEpcsModal_modalForm__25_Nt","modalFooter":"UpgradeEpcsModal_modalFooter__3Titz"};